import { render, staticRenderFns } from "./PanelMonitoring.vue?vue&type=template&id=44876944&scoped=true"
import script from "./PanelMonitoring.vue?vue&type=script&lang=js"
export * from "./PanelMonitoring.vue?vue&type=script&lang=js"
import style0 from "./PanelMonitoring.vue?vue&type=style&index=0&id=44876944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44876944",
  null
  
)

export default component.exports